/**
 * Sincronizzazione HTML ↔ testo semplice (solo paragrafi e <br> in uscita dal testo).
 */

export function htmlToPlain(html) {
  if (!html || !String(html).trim()) return '';
  try {
    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    const text = doc.body.innerText != null ? doc.body.innerText : doc.body.textContent || '';
    return text.replace(/\u00a0/g, ' ');
  } catch {
    return String(html)
      .replace(/<[^>]+>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
}

export function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Converte testo semplice in HTML minimale: blocchi separati da riga vuota → <p>, singolo a capo → <br> */
export function plainToSimpleHtml(plain) {
  const t = String(plain).replace(/\r\n/g, '\n').trimEnd();
  if (!t) return '';
  const blocks = t.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  if (blocks.length === 0) return '<p></p>';
  return blocks
    .map((block) => {
      const withBr = escapeHtml(block).replace(/\n/g, '<br>');
      return `<p>${withBr}</p>`;
    })
    .join('\n');
}
